// extracted by mini-css-extract-plugin
export default {"root":"NotFoundPage_root__M146k","content":"NotFoundPage_content__8yDN+","appImage":"NotFoundPage_appImage__K5UYc"};